import axiosInstance from "../../Api/Axios";

export const handleDownload = async (request_type, invoiceNumber) => {
  const apiEndpoint = `${process.env.REACT_APP_API_URL}/download?request_type=${request_type}&invoice_number=`+invoiceNumber;

  try {
    const response = await axiosInstance.get(apiEndpoint, {
      responseType: 'blob'  // Specify that the response is a binary blob
    });

    // Create a download link and trigger the download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Facture-${invoiceNumber}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error downloading file:', error);
    // Handle errors as needed
  }
};